<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-rollback" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path
      d="M3.5 10C3.5 13.866 6.63401 17 10.5 17C14.366 17 17.5 13.866 17.5 10C17.5 6.13401 14.366 3 10.5 3C8.54131 3 6.77052 3.80447 5.5 5.10102"
      stroke="#33E672"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M5.12573 2L4.49999 5.95075L8.45075 6.57649"
      stroke="#33E672"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseSvg>
</template>
